import fixedWorkplace from './fixedWorkplace';

export default {
  address: [...fixedWorkplace.address],
  'about-object': [...fixedWorkplace['about-object']],
};
